import { progressRound } from '@/helpers/format'
// import _ from 'lodash'

// export default (goalEntity) => new GoalEntity(goalEntity)

export const computeProgressPercent = ({currentProgress, max}) => {
  let rawProgress = 0

  rawProgress = 100 * currentProgress / max

  return progressRound(rawProgress)
}

// class GoalEntity {
//   constructor (goalEntity) {
//     this.goalEntity = goalEntity
//   }
// }
